var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fc-container"},[_c('h2',{staticClass:"fc-heading-1 fc-padding-bottom-10 fc-text-center"},[_vm._v("\n    Frequently Asked Questions\n  ")]),_vm._v(" "),_c('FaqsCollapsibleContainer',{attrs:{"container":_vm.faqs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }